import React from "react";

import macaronStrawberry     from "../assets/macaron-strawberry.png";
import macaronVanilla        from "../assets/macaron-vanilla.png";
import macaronChocolate      from "../assets/macaron-chocolate.png";
import macaronToastedCoconut from "../assets/macaron-toasted-coconut.png";

const IMAGES = [
  macaronStrawberry,
  macaronVanilla,
  macaronChocolate,
  macaronToastedCoconut,
];

const DEFAULT_POSITIONS = [
  { top: "10%", left: "6%",  delay: 0,   size: 52 },
  { top: "30%", left: "8%",  delay: 1.4, size: 44 },
  { top: "52%", left: "6%",  delay: 0.7, size: 56 },
  { top: "72%", left: "8%",  delay: 1.9, size: 44 },
  { top: "88%", left: "6%",  delay: 0.3, size: 48 },
  { top: "8%",  left: "83%", delay: 0.5, size: 50 },
  { top: "28%", left: "84%", delay: 1.1, size: 44 },
  { top: "50%", left: "83%", delay: 0.2, size: 52 },
  { top: "70%", left: "84%", delay: 1.6, size: 44 },
  { top: "86%", left: "83%", delay: 0.8, size: 48 },
];

export default function FloatingMacarons({ positions = DEFAULT_POSITIONS }) {
  return (
    <>
      {positions.map((m, i) => (
        <div
          key={i}
          className="absolute hidden lg:block select-none pointer-events-none"
          style={{
            top: m.top,
            left: m.left,
            opacity: 0.82,
            animation: `float-${i % 4} ${3.8 + i * 0.5}s ease-in-out infinite`,
            animationDelay: `${m.delay}s`,
          }}
        >
          <img
            src={IMAGES[Math.floor(Math.random() * IMAGES.length)]}
            alt=""
            style={{ width: m.size, height: m.size, objectFit: "contain" }}
          />
        </div>
      ))}
    </>
  );
}
